import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createStyleManager, StyleManager } from 'jss-theme-reactor';
import jssPreset from '@/styles/utils/preset';
import { createMuiTheme, ITheme } from './theme';
import { StyleManagerContext } from './StyleManagerContext';

// Use require for JSS create to avoid ESM/CJS issues
const { create } = require('jss');

interface IStyleManagerProviderProps {
  styleManager?: StyleManager;
  theme?: ITheme;
  children?: React.ReactNode;
}

export default class StyleManagerProvider extends Component<IStyleManagerProviderProps> {
  static childContextTypes = {
    styleManager: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
  };

  styleManager: StyleManager;
  theme: ITheme;

  constructor(props: IStyleManagerProviderProps) {
    super(props);
    this.theme = props.theme || createMuiTheme();
    this.styleManager = props.styleManager || createStyleManager({
      theme: this.theme,
      jss: create(jssPreset({})),
    });
  }

  getChildContext() {
    return {
      styleManager: this.styleManager,
      theme: this.theme,
    };
  }

  render() {
    // Provide both legacy context (via getChildContext) and new Context API
    const contextValue = {
      styleManager: this.styleManager,
      theme: this.theme,
    };

    return (
      <StyleManagerContext.Provider value={contextValue}>
        {this.props.children}
      </StyleManagerContext.Provider>
    );
  }
}